var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 8.27005C10.4 9.79294 9.326 11.0264 8 11.0264C6.674 11.0264 5.6 9.79294 5.6 8.27005C5.6 6.74716 6.674 5.51368 8 5.51368C9.326 5.51368 10.4 6.74716 10.4 8.27005ZM8 11.8746C5.6088 11.8746 3.356 10.5183 1.9192 8.27005C3.356 6.02184 5.6088 4.66452 8 4.66452C10.3912 4.66452 12.644 6.02184 14.0808 8.27005C12.644 10.5183 10.3912 11.8746 8 11.8746ZM8 2.75684C4.5792 2.75684 1.5992 4.97738 0 8.27005C1.5992 11.5627 4.5792 13.7823 8 13.7823C11.4208 13.7823 14.4008 11.5627 16 8.27005C14.4008 4.97738 11.4208 2.75684 8 2.75684Z",
    fill: "#6B7078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28767 0.739058C1.62777 0.348461 2.23458 0.348461 2.57468 0.739058L14.2433 14.1403C14.523 14.4615 14.523 14.9398 14.2433 15.2609C13.9032 15.6515 13.2964 15.6515 12.9563 15.2609L1.28767 1.85967C1.008 1.53848 1.008 1.06025 1.28767 0.739058Z",
    fill: "#6B7078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.4682a85985601c683adcc79e9f9a7d87.svg";
export { ForwardRef as ReactComponent };